import ReactGA from "react-ga4";

const ga4Mid =
  window.location.host === "statistique.quebec.ca"
    ? "G-50E0KJDQC1"
    : window.location.host === "validation-siteweb-isq.isq-prod.stat"
    ? "G-3GREVJ6T1N"
    : "G-33H9HV0Y2Y";

const initGA4 = () => {
  ReactGA.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "granted",
  });
  ReactGA.initialize([
    {
      trackingId: ga4Mid,
      gtagOptions: {
        cookie_prefix: "ga4",
        site: "Commerce international en ligne",
        debug: false,
      },
    },
    {
      trackingId: "UA-117804164-3",
      gtagOptions: { debug: false },
    },
  ]);
};

export { initGA4 };
